.Error-handler {
  text-align: center;
  margin-top: 50px;

  .Error-handler-button {
    margin-top: 15px;
    color: var(--color_primary_500);
    font-weight: bold;
  }
}